"use client";

import { Check, Link2, Twitter } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { writeToClipboard } from "@/lib/clipboard";

interface ShareButtonsProps {
  title: string;
  url: string;
}

export function ShareButtons({ title, url }: ShareButtonsProps) {
  const [copied, setCopied] = useState(false);

  async function handleCopyLink() {
    if (await writeToClipboard(url)) {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } else {
      toast.error("Couldn't copy the link. Please copy it manually.");
    }
  }

  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`;

  return (
    <div className="flex items-center gap-2 print:hidden">
      <Button
        className="gap-1.5 text-xs"
        onClick={handleCopyLink}
        size="sm"
        variant="ghost"
      >
        {copied ? (
          <Check className="size-3.5" />
        ) : (
          <Link2 className="size-3.5" />
        )}
        {copied ? "Copied!" : "Copy link"}
      </Button>
      <Button asChild className="gap-1.5 text-xs" size="sm" variant="ghost">
        <a href={twitterUrl} rel="noopener noreferrer" target="_blank">
          <Twitter className="size-3.5" />
          Share
        </a>
      </Button>
    </div>
  );
}
